import { createApiAction, restApiActions } from 'redux/redux-actions';
import restApis from '../restApis';
import {
  CONFIRM_ALL_INVOICES,
  HAS_DELIVERY_FEE_ORDER,
  MARK_AS_PAID,
  DAILY_SALES_PURCHASES,
  MONTHLY_PURCHASES,
  MONTHLY_PURCHASES_LIST,
  MONTHLY_SALES,
  MONTHLY_SALES_LIST,
  PACK_LIST,
  PICK_LIST,
  WAREHOUSE_LIST,
  SEND_ORDER_UPDATE_EMAIL,
} from '../constants';

const confirmAllInvoicesApi = restApis('orders/confirm-all');
const dailySalesPurchasesApi = restApis('orders/daily-sales-purchases');
const monthlyPurchasesApi = restApis('orders/monthly-purchases');
const monthlySalesApi = restApis('orders/monthly-sales');
const packListApi = restApis('orders/pack-list');
const pickListApi = restApis('orders/pick-list');
const warehouseListApi = restApis('orders/warehouse-list');
const updateEmailApi = restApis('orders', 'sendUpdateEmail');
const deliveryFeeOrderApi = restApis('has-delivery-fee-order');
const markAsPaidApi = restApis('orders', 'mark-as-paid').create;

export const confirmAllInvoices = createApiAction(
  CONFIRM_ALL_INVOICES, confirmAllInvoicesApi.create,
);
export const getDailySalesPurchases = createApiAction(DAILY_SALES_PURCHASES, dailySalesPurchasesApi.read);
export const getMonthlyPurchases = createApiAction(MONTHLY_PURCHASES, monthlyPurchasesApi.read);
export const getMonthlyPurchasesList = createApiAction(
  MONTHLY_PURCHASES_LIST, monthlyPurchasesApi.list);
export const getMonthlySales = createApiAction(MONTHLY_SALES, monthlySalesApi.read);
export const getMonthlySalesList = createApiAction(MONTHLY_SALES_LIST, monthlySalesApi.list);
export const getPackList = createApiAction(PACK_LIST, packListApi.list);
export const getPickList = createApiAction(PICK_LIST, pickListApi.list);
export const getWarehouseList = createApiAction(WAREHOUSE_LIST, warehouseListApi.list);
export const sendOrderUpdateEmail = createApiAction(SEND_ORDER_UPDATE_EMAIL, updateEmailApi.create);
export const hasDeliveryFeeOrder =
  createApiAction(HAS_DELIVERY_FEE_ORDER, deliveryFeeOrderApi.list);
export const markAsPaid = createApiAction(MARK_AS_PAID, markAsPaidApi);

export default restApiActions('orders');
